import { Section, SectionHead } from "@/components/landing/Section";

const STEPS = [
  { t: "Vos critères", d: "Indiquez votre ville, votre budget, votre durée et le nombre de voyageurs." },
  { t: "3 escapades cohérentes", d: "Wanderlust compose trois escapades locales cohérentes et faciles à comparer." },
  { t: "Votre préférée, en détail", d: "Choisissez votre préférée et débloquez l'itinéraire détaillé pour 4,90 €." },
];

export const HowItWorks = () => (
  <div className="bg-white border-y border-gray-200">
    <Section id="comment">
      <SectionHead eyebrow="Simple" title="Comment ça marche" />
      <ol className="mt-12 grid md:grid-cols-3 gap-10">
        {STEPS.map((s, i) => (
          <li key={s.t} data-testid={`how-step-${i + 1}`} className="relative border-t-2 border-amber-600 pt-6">
            <span className="font-serif text-5xl font-bold text-amber-600/20">0{i + 1}</span>
            <h3 className="mt-2 font-serif text-xl font-semibold text-[#0B131E]">{s.t}</h3>
            <p className="mt-2 text-sm text-gray-600 leading-relaxed">{s.d}</p>
          </li>
        ))}
      </ol>
      <a href="#recherche" data-testid="how-cta-btn" className="mt-12 inline-flex items-center h-12 px-7 rounded-full bg-[#0B131E] text-white font-semibold hover:bg-amber-600 transition-colors">
        Trouver mon escapade
      </a>
    </Section>
  </div>
);
